import axios, { Axios } from "axios";
import { useFormik } from "formik";
import { Divider } from "material-ui";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { ContextMenu } from "primereact/contextmenu";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Chip from "./Chip";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";


function ManageOrders(props)
{

    const [orders,setOrders] = useState([]);
    const [updateOrders,setUpdateOrders] = useState(0);
    const [selectedOrder, setSelectedOrder] = useState({});
    const cm = useRef(null);
    const toast = useRef(null);
    const token = JSON.parse(localStorage.getItem('userToken'));
    const config = {  headers: {"Content-Type": "application/json",Authorization: `Bearer ${token}`} };
    const navigate = useNavigate();
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [showEditOrder, setShowEditOrder] = useState(false);
    

    // body templates ************************************************************************************:

    const sellerBodyTemplate = (rowData) =>
    {
        return <div>
            {rowData.sellers_id.map( (seller,index) => { return <span  key={index}>
            
             <Link to={"/"+seller.username+"/about"} style={{display:"flex",alignItems:'center', marginBottom:"10px"}}
            state={{ page:  {_id:seller._id, username:seller.username, name:seller.name , avatarPic:seller.avatarPic} , isPage:true , isUserPage:false }}>
                <img 
                src={`${process.env.REACT_APP_BACK}/avatars/${seller.avatarPic}`}
                style={{height:"40px",width:"40px",borderRadius:"50%"}}></img>
                
                <h6 style={{marginRight:"10px"}}>{seller.name}</h6>
            </Link>
            </span>
            })
            }
        </div>
        
       

    }

    const chosenBodyTemplate = (rowData) =>
    {
        return <div>
            {rowData.chosen_sellers_id.map( (seller,index) => { return <span  key={index}>
            
             <Link to={"/"+seller.username+"/about"} style={{display:"flex",alignItems:'center', marginBottom:"10px"}}
            state={{ page:  {_id:seller._id, username:seller.username, name:seller.name , avatarPic:seller.avatarPic} , isPage:true , isUserPage:false }}>
                <img 
                src={`${process.env.REACT_APP_BACK}/avatars/${seller.avatarPic}`}
                style={{height:"40px",width:"40px",borderRadius:"50%"}}></img>
                
                <h6 style={{marginRight:"10px"}}>{seller.name}</h6>
            </Link>
            </span>
            })
            }
        </div>
        
       

    }



  
    const dateCreatedBodyTemplate = (rowData) => {
        return new Date(rowData.dateCreated).toLocaleDateString('fa-IR');
    };
    /*******************************************************************************************************/ 


    
    const menuModel = [
        {label: 'ویرایش', icon: 'pi pi-fw pi-pencil', command: () => setShowEditOrder(true)},
        {label: 'حذف', icon: 'pi pi-fw pi-trash', command: () => setShowConfirmDelete(true)}
    ];


    const deleteOrderFromDB = async (_id) => 
    {
      await axios.delete(process.env.REACT_APP_BACK+"/orders/" + _id, config)
      .then(response => 
        {
          if (response.status == 200)
          {
            
            toast.current.show({severity: 'info', summary: 'سفارش حذف شد'});
            setUpdateOrders(updateOrders+1);    
            
          }

      })
      .catch(error => {
         console.log(error);
         if(error.response.data.statusCode===401)
              navigate("/login")
      });
    };

   

    //get all orders from database:
    useEffect(() => {
    async function getAllOrders() {

      
      const result = await axios.get(process.env.REACT_APP_BACK+"/orders/all", config)
      .then((result) => {
        if (result.status == 200) {
          setOrders(result.data);
        
          
          return result.data;
        }
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.statusCode===401)
              navigate("/login")
      });
      return result.data;

    }
    getAllOrders();
  },[updateOrders]);

  
   //initialize formik:
   useEffect(() => {
    async function initForm() {

      editOrderForm.values.customer_phone = selectedOrder.customer_phone;
      editOrderForm.values.tag = selectedOrder.tag;
      editOrderForm.values.content = selectedOrder.content;
      editOrderForm.values.status = selectedOrder.status;


    }
    initForm();
  },[selectedOrder]);

  const editOrderForm = useFormik({
    initialValues: {
      customer_phone : selectedOrder["customer_phone"],
      tag : selectedOrder["tag"],
      content : selectedOrder["content"],
      status : selectedOrder["status"],
      
    },

    onSubmit: (values) => {


      const obj = {};

      for (const key in values) {

        if(key !== "")
        {
          obj[key] = values[key];
        }
        
    }

      const data = JSON.stringify(obj);
 
      
   
    axios.patch(process.env.REACT_APP_BACK+"/orders/update-order/"+selectedOrder._id, data, config)
        .then(response => 
          {

          if(response.status == 200)
          {
            
            setShowEditOrder(false);
            setUpdateOrders(updateOrders+1);
      
          }

        })
        .catch(error => {
           console.log(error);
           if(error.response.data.statusCode===401)
              navigate("/login")
        });

        
      
    },
  });

    

    return(

        <div id="manage-orders">

            <h2>
            مدیریت سفارش ها
            </h2>

            <Toast ref={toast}></Toast>

            <ContextMenu model={menuModel} ref={cm} />

            <DataTable size="normal" value={orders} paginator rows={20} editMode="row"
            className="manager-table"
            contextMenuSelection={selectedOrder}
            onContextMenuSelectionChange={e => setSelectedOrder(e.value)}
            onContextMenu={e => cm.current.show(e.originalEvent)}>
            
            
            <Column alignHeader="center" columnKey="tag" align="center" field="tag" header="محصول درخواستی" style={{width:"50px"}} sortable filter ></Column>
            <Column alignHeader="center" columnKey="content" align="center" field="content" header="محتوای سفارش"  style={{width:"150px"}} filter></Column>
            <Column alignHeader="center" columnKey="customer_phone" align="center" field="customer_phone" header="شماره مشتری" style={{width:"50px"}} sortable filter ></Column>
            <Column alignHeader="center" columnKey="sellers" align="center" field="sellers" header=" فروشندگان"style={{width:"100px"}}  body={sellerBodyTemplate} sortable  ></Column>
            <Column alignHeader="center" columnKey="whatsappLinks" align="center" field="whatsappLinks" header="فروشنده انتخابی کاربر" style={{width:"150px"}} body={chosenBodyTemplate} filter sortable></Column>
            <Column alignHeader="center" columnKey="status" align="center" field="status" header="وضعیت" style={{width:"50px"}}  filter sortable></Column>
            <Column alignHeader="center" columnKey="regDate" align="center" field="dateCreated" header="تاریخ ایجاد" style={{width:"50px"}} body={dateCreatedBodyTemplate} sortable></Column>
            
            
            </DataTable>


            <ConfirmDialog 
            className={props.theme}
            visible={showConfirmDelete} 
            onHide={() => setShowConfirmDelete(false)} 
            message="آیا از حذف این سفارش مطمئنید؟"
            header="تایید حذف"
            icon="pi pi-info-circle"
            acceptLabel="بله"
            rejectLabel="نه"
            acceptClassName="accept"
            rejectClassName="reject"
            accept={() => deleteOrderFromDB(selectedOrder._id)} 
            reject={() => setShowConfirmDelete(false)} />

            <Dialog
            className={props.theme}
                id="edit-user-dialog"
                header="ویرایش سفارش"
                visible={showEditOrder}
                onHide={() => setShowEditOrder(false)}
                >
            
          <form onSubmit={editOrderForm.handleSubmit} className="p-fluid">
          <div className="field">
                <span>
                  <label htmlFor="name">شماره مشتری</label>
                  <InputNumber
                    id="customer_phone"
                    name="customer_phone"
                    value={editOrderForm.values.customer_phone}
                    
                     onValueChange={(e) => editOrderForm.setFieldValue("customer_phone", e.value)}
                  />
                </span>
  
            
            </div>

            <div className="field">
              <label htmlFor="bio">محصول درخواستی</label>
              <span className=" p-input-icon-left">
                <InputText
                  id="tag"
                  name="tag"
                  value={editOrderForm.values.tag}
                  onChange={editOrderForm.handleChange}
                />
              </span>
            </div>

            <div className="field">
              <label htmlFor="prises">وضعیت سفارش</label>
              <span className=" p-input-icon-left">
                <Dropdown
                  id="status"
                  name="status"
                  value={editOrderForm.values.status}
                  onChange={editOrderForm.handleChange}
                  options={["دریافت شده","ارسال شده به فروشنده","ارسال پاسخ به مشتری","خرید انجام شده"]}
                  
                />
              </span>
            </div>

            <div className="field">
              <label htmlFor="prises">متن سفارش</label>
              <span className=" p-input-icon-left">
              <InputTextarea
                    id="content"
                    name="content"
                    rows={5}
                    onChange={editOrderForm.handleChange}
                    value={editOrderForm.values.content}
                    checked={editOrderForm.values.content}

                  />
              
              </span>
            </div>


          
        

          

            <div className="two-columns">
              <div className="field col-one">
                <span>
                  <Button type="submit" label="ذخیره" className="mt-2" />
                </span>
              </div>

              <div className="field col-two">
                <span>
                  <Button
                    className="outline-button mt-2"
                    type="button"
                    label="انصراف"
                    onClick={() => setShowEditOrder(false)}
                  />
                </span>
              </div>
            </div>
          </form>
        

        
            </Dialog>

        </div>
    );
}
  
export default ManageOrders;